import { LOCALIZED_PATHS } from '../constants/url-constants';
import type { Locale } from '../routing/generate-url';
import { buildMapUrlHash } from './map-url-hash';
import { isSeaFallbackGeoloc } from './sea-fallback-geoloc';

/** Street-ish zoom: close enough to see the job's pin and neighborhood, wide enough for context. */
const JOB_MAP_ZOOM = 11;

/**
 * Relative SRP-map link centered on a job's location (`?view=map` + shared-viewport hash), for
 * the job detail page's "see on map & check your commute" link. Null when the job has no real
 * coordinates (missing or sea-parked placeholder) — no link beats a link to open water.
 */
export function buildJobMapCommuteHref(
  locale: Locale,
  geoloc: Array<{ lat?: unknown; lng?: unknown }> | { lat?: unknown; lng?: unknown } | null | undefined,
): string | null {
  const candidates = Array.isArray(geoloc) ? geoloc : geoloc ? [geoloc] : [];
  const point = candidates.find(
    (p) =>
      p &&
      Number.isFinite(p.lat as number) &&
      Number.isFinite(p.lng as number) &&
      !isSeaFallbackGeoloc(p as { lat: number; lng: number }),
  ) as { lat: number; lng: number } | undefined;
  if (!point) return null;
  const hash = buildMapUrlHash({
    center: { lat: point.lat, lng: point.lng },
    zoom: JOB_MAP_ZOOM,
    recentOnly: false,
    perCapita: false,
  });
  return `/${locale}/${LOCALIZED_PATHS[locale].jobs}?view=map${hash}`;
}
